<template>
  <a-layout-sider
    :class="['sider', isDesktop() ? null : 'shadow', theme, fixSiderbar ? 'ant-fixed-sidemenu' : null ]"
    width="256px"
    :collapsible="collapsible"
    v-model="collapsed"
    :trigger="null">
    <logo />
    <s-menu
      :collapsed="collapsed"
      :menu="menus"
      :theme="theme"
      :mode="mode"
      @select="onSelect"></s-menu>
  </a-layout-sider>

</template>

<script>
import ALayoutSider from 'ant-design-vue/es/layout/Sider'
import Logo from '../tools/Logo'
import SMenu from './index'
import { mixin, mixinDevice } from '@/utils/mixin.js'

export default {
  name: 'SideMenu',
  components: { ALayoutSider, Logo, SMenu },
  mixins: [mixin, mixinDevice],
  props: {
    mode: {
      type: String,
      required: false,
      default: 'inline'
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menus: {
      type: Array,
      required: true
    }
  },
  methods: {
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    }
  }
}
</script>

<style lang="less" scoped>
.ant-layout-sider,
.ant-menu-dark {
  background: #303030;
}
/deep/.ant-layout-sider-children {
  overflow-y: auto;
}
.sider {
    box-shadow: 2px 0 6px rgba(0, 21, 41, .35);
    position: relative;
    z-index: 10;

    .ant-layout-sider-children:hover {
      overflow-y: auto;
    }

    &.ant-fixed-sidemenu {
      position: fixed;
      height: 100%;
    }

    &.dark{
      /deep/ .ant-menu{
        padding: 4px 0;
        .ant-menu-item,
        .ant-menu-submenu-title {
          // a {
          //   font-size: 14px;
          //   color: #EDEEF2;
          //   .iconfont{
          //     min-width: 14px;
          //     margin-right: 16px;
          //   }
          // }
          font-size: 14px;
          color: rgba(255, 255, 255, 0.65);
          .iconfont{
            min-width: 14px;
            margin-right: 16px;
          }
        }
        &.ant-menu-inline-collapsed {
          .ant-menu-item {
            a {
              span{
                max-width: 0;
                opacity: 0;
                font-size: 0;
              }
            }
          }
          .ant-menu-submenu-title {
            span>span {
              opacity: 0;
              font-size: 0;
            }
          }
        }
      }
    }

  }
</style>
